class ThemeModeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#onClick);
    this.#syncLabel();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onClick);
  }

  #onClick = () => {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    const nextTheme = isDark ? 'light' : 'dark';

    if (nextTheme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }

    try {
      localStorage.setItem('gfwf-theme', nextTheme);
    } catch (e) {}

    this.#syncLabel();
  };

  #syncLabel() {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    this.button?.setAttribute('aria-pressed', String(isDark));
  }
}

if (!customElements.get('theme-mode-toggle')) {
  customElements.define('theme-mode-toggle', ThemeModeToggle);
}
